export const FEDERAL_REGISTER_URL =
  'https://www.federalregister.gov/documents/2016/05/11/2016-10567/customer-due-diligence-requirements-for-financial-institutions#footnote-%5B%E2%80%A6%5D44-p29407';
export const IRS_W9_DOCS_URL = 'https://www.irs.gov/pub/irs-pdf/iw9.pdf';
